export default "__VITE_ASSET__CLAmFKaD__"